import { nullableNumberSchema } from '@almaris/shared/schemas'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import * as yup from 'yup'

export const useEstateSettingOpeningFormPricesSchema = () => {
  const { t } = useTranslation(undefined, { keyPrefix: 'Forms.errors' })

  const schema = useMemo(
    () =>
      yup.object().shape({
        firstPrice: yup.number().typeError(t('number')).required(t('required')),
        reservePrice: nullableNumberSchema,
      }),
    [t]
  )

  return { schema }
}

export type EstateSettingOpeningFormPricesValues = yup.InferType<
  ReturnType<typeof useEstateSettingOpeningFormPricesSchema>['schema']
>
